import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const DotsIcon: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm8.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm6 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
        />
    </svg>
);
